// Sticky mobile "Add to order" bar (templates/product.liquid). Shows once the main add button
// has scrolled above the viewport, and hides again when it is back on screen or the footer is
// reached. Tapping the bar clicks the real add button, so quantity, quantity rules and the
// order drawer all behave exactly as in the buy box.
class SStickyBuy extends HTMLElement {
  connectedCallback() {
    if (this.closest('dialog')) { this.remove(); return; }
    this.anchor = document.querySelector('[data-sticky-anchor]');
    if (!this.anchor || !('IntersectionObserver' in window)) return;
    this.button = this.querySelector('[data-sticky-add]');
    this.button?.addEventListener('click', () => {
      this.anchor.querySelector('button[type="submit"]')?.click();
    });
    this.past = false;
    this.footerVisible = false;
    this.io = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (e.target === this.anchor) this.past = !e.isIntersecting && e.boundingClientRect.top < 0;
        else this.footerVisible = e.isIntersecting;
      }
      this.toggle(this.past && !this.footerVisible);
    });
    this.io.observe(this.anchor);
    const footer = document.querySelector('footer');
    if (footer) this.io.observe(footer);
  }
  toggle(show) {
    this.toggleAttribute('data-visible', show);
    this.setAttribute('aria-hidden', show ? 'false' : 'true');
    this.inert = !show;
  }
  disconnectedCallback() {
    this.io?.disconnect();
  }
}
if (!customElements.get('s-sticky-buy')) customElements.define('s-sticky-buy', SStickyBuy);
